export default {
    apiBaseUrl: window.CONFIG.ApiBaseUrl
};
